import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "19",
  viewBox: "0 0 22 19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("line", {
      x1: "0.896484",
      y1: "1.50781",
      x2: "20.518",
      y2: "1.50781",
      stroke: "#231F20",
      "stroke-width": "1.75",
      "stroke-linecap": "square"
    }, null, -1),
    _createElementVNode("line", {
      x1: "0.896484",
      y1: "9.75781",
      x2: "20.518",
      y2: "9.75781",
      stroke: "#231F20",
      "stroke-width": "1.75",
      "stroke-linecap": "square"
    }, null, -1),
    _createElementVNode("line", {
      x1: "0.896484",
      y1: "18.0078",
      x2: "20.518",
      y2: "18.0078",
      stroke: "#231F20",
      "stroke-width": "1.75",
      "stroke-linecap": "square"
    }, null, -1)
  ]))]))
}
export default { render: render }